import { api } from './api';

export const requestService = {
  /**
   * List requests with optional filters
   * @param {Object} params - { status, carrier_id, start_date, end_date, limit, cursor, signal }
   */
  list: (params = {}) => {
    const { signal, ...queryParams } = params;
    return api.get('/requests', { params: queryParams, signal });
  },

  /**
   * Get request by ID
   */
  getById: (id) => api.get(`/requests/${id}`),

  /**
   * Create new request
   */
  create: (data) => api.post('/requests', data),

  /**
   * Update request
   */
  update: (id, data) => api.put(`/requests/${id}`, data),

  /**
   * Soft delete request
   */
  delete: (id) => api.delete(`/requests/${id}`),

  /**
   * Update request status
   */
  updateStatus: (id, status) => api.put(`/requests/${id}/status`, { status }),

  /**
   * Assign carrier to request
   */
  assignCarrier: (id, carrierId) => api.put(`/requests/${id}/carrier`, { carrier_id: carrierId }),

  /**
   * Unassign carrier from request
   */
  unassignCarrier: (id) => api.delete(`/requests/${id}/carrier`),

  /**
   * Update quote details
   */
  updateQuote: (id, quoteData) => api.put(`/requests/${id}/quote`, quoteData),

  /**
   * Set AI processing status
   */
  setAIProcessing: (id, isProcessing) => api.post(`/requests/${id}/ai-process`, { is_processing: isProcessing }),

  /**
   * Send clarification reply to carrier (one-shot per RFQ).
   * Returns 409 CLARIFICATION_LOCKED if the reply was already used.
   */
  sendClarification: (id, clarificationNotes) => api.post(`/requests/${id}/clarification`, { clarification_notes: clarificationNotes }),

  /**
   * Mark RFQ as offline follow-up — only allowed from needs_clarification.
   * After this, further carrier emails get auto-handed-off by the Lambda
   * mailgun handler and do not surface back into the app.
   */
  markOfflineFollowup: (id) => api.post(`/requests/${id}/offline-followup`),

  /**
   * Mark the RFQ as seen by the current user at its current status.
   * Clears the NEW badge until the status changes. Idempotent — backend
   * upserts a per-(user, request) view record. Fire-and-forget at call sites.
   */
  markSeen: (id) => api.post(`/requests/${id}/seen`),

  confirmSend: (id, rfqText) => api.post(`/requests/${id}/confirm-send`, { rfq_text: rfqText }),

  extractRFQ: (rfqText, carrierTypes) => api.post('/requests/extract', { rfq_text: rfqText, carrier_types: carrierTypes }),

  validateRFQ: (rfqText) => api.post('/requests/validate', { rfq_text: rfqText }),

  getValidationStatus: (validationId) => api.get(`/requests/validate/${validationId}`),

  submitRFQ: (rfqText, carrierId, extraction, validationId) => api.post('/requests/submit', {
    rfq_text: rfqText,
    carrier_id: carrierId,
    extraction,
    validation_id: validationId,
  }),
};
